import React, { Component } from "react";
import { connect } from "react-redux";
import backlogo from "../../assets/images/svg/Back.svg";
import { Link } from "react-router-dom";
import { FormGroup, Button, Label, Input } from "reactstrap";
import CustomTable from "../Components/CustomTable";
import { getColumns } from "./../../utils/tableHeaders";
import { SELECTOPTIONS } from "./../../constant/furtherAnalysis";
import {
  fetchTableData,
  fetchTableDataAllDownload,
} from "./../../utils/fetchTableData";
import Loader from "react-loaders";
import axiosInstance from "../configuration/Request";
import { ToastContainer } from "react-toastify";
import { showErrorToast } from "../Components/Toaster";
import CytoscapeGraph from "./CytoscapeGraph";

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};

class FurtureAnalysisResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: "Tumorigenesis",
      allResultsChecked: true,
      tableData: [],
      loading: false,
      tableColumn: [],
      errorMessage:
        "No records available or option not selected on the previous page.",
      page: 1,
      rowsPerPage: 10,
      totalRows: 0,
      descriptionText: "",
      nodeData: {},
      tableType: "",
      selectedOperations: ""
    };
    this.cytoscapeRef = React.createRef();
  }

  componentDidMount() {
    this.constructData(
      this.state.selectedOption,
      this.state.page,
      this.state.rowsPerPage
    );

    // Only fetch cytoscape details for Networks, not for Projects
    const isFromProject = this.props?.reduxData?.furtureAnalysisDetails?.isFromProject || false;
    if (!isFromProject) {
      this.fetchCytoscapeDetails();
    }

    const data = this.props?.reduxData?.furtureAnalysisDetails?.viewDetails
    const selectedKeys = Object.keys(data).filter(key => data[key]?.selected);
    const keys = selectedKeys?.join(",")?.replace("_", " ")
    this.setState({
      selectedOperations: keys
    });
  }

  constructData = async (value, currentPage, limit) => {
    if (
      this.props?.reduxData?.furtureAnalysisDetails?.viewDetails[value]?.selected
    ) {

      this.fetchTableDetails(value, currentPage, limit);
    }
    else {
      this.setState({
        descriptionText: "",
      });
    }
  };

  fetchTableDetails = async (value, currentPage, limit) => {
    this.setState({
      loading: true,
      errorMessage: "Loading...",
      tableColumn: getColumns(
        value,
        this.props?.reduxData?.furtureAnalysisDetails?.centrality
      ),
    });
    try {
      let operationDetails = {
        ...this.props?.reduxData?.furtureAnalysisDetails,
        type: value,
      };
      const response = await fetchTableData(
        operationDetails,
        currentPage,
        limit,
        "result"
      );
      if (!response) {
        this.setState({
          descriptionText: "",
        });
        throw new Error("Failed to fetch data");
      }
      const firstKey = Object.keys(response)[0];
      if (
        Array.isArray(response[firstKey]) &&
        response[firstKey].length === 0
      ) {
        this.setState({
          descriptionText: "",
          errorMessage:
            "No records available or option not selected on the previous page.",
        });
      } else {
        this.setState({
          tableData: this.getData(
            response,
            value,
            this.props?.reduxData?.furtureAnalysisDetails.viewDetails[value]
          ),
        });
        this.setState({
          errorMessage:
            "No records available or option not selected on the previous page.",
        });
      }
    } catch (error) {
      this.setState({
        errorMessage:
          error?.response?.data?.details ||
          "No records available or option not selected on the previous page.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handlePageChange = (newPage) => {
    this.setState({
      page: newPage,
    });
    this.fetchTableDetails(
      this.state.selectedOption,
      newPage,
      this.state.rowsPerPage
    );
  };

  handleRowsPerPageChange = (newLimit) => {
    this.setState({
      page: 1,
      rowsPerPage: newLimit,
    });
    this.fetchTableDetails(this.state.selectedOption, 1, newLimit);
  };

  handleSelection = (value) => {
    if (value !== this.state.selectedOption) {
      this.setState({
        selectedOption: value,
        tableData: [],
        errorMessage:
          "No records available or option not selected on the previous page.",
        page: 1,
        rowsPerPage: 10,
        tableType: value,
      });
      if (value === "Centrality" && this.props?.reduxData?.furtureAnalysisDetails?.centrality) {
        this.setState({
          descriptionText: "",
        });
        this.fetchTableDetails(value, 1, 10);
      } else if (value === "Pathway" && this.props?.reduxData?.furtureAnalysisDetails?.pathway) {
        this.setState({
          descriptionText: "",
        });
        this.fetchTableDetails(value, 1, 10);
      } else if (value === "Significant_Condition" && this.props?.reduxData?.furtureAnalysisDetails?.significantCondition) {
        this.setState({
          descriptionText: "",
        });
        this.fetchTableDetails(value, 1, 10);
      }
      else {
        this.constructData(value, 1, 10);
      }

    }
  };

  getData = (response, type, operationDetails) => {
    const histological_subtype =
      this.props?.reduxData?.furtureAnalysisDetails.histological_subtype;

    if (!response) return [];

    const setPagination = (section) => {
      this.setState({
        totalRows: response?.[section]?.pagination?.total,
        page: response?.[section]?.pagination?.page,
        rowsPerPage: response?.[section]?.pagination?.pageSize,
      });
    };

    const getTumorigenesisDescription = () => {
      const fdr = operationDetails.fdr ? `, FDR < ${operationDetails.fdr}` : "";
      const direction = operationDetails.fc_threshold === "low" ? "<" : ">";
      const foldChange = operationDetails.fold_change
        ? `,Log2 Fold Change ${direction} ${operationDetails.fold_change}`
        : "";
      return (
        `Tumorigenesis genes are defined as those exhibiting significantly differential mRNA expression between tumor and normal tissues (p < 0.05` +
        `${fdr}${foldChange}) in the TCGA ${histological_subtype} patient cohort.`
      );
    };

    const getSurvivalDescription = () => {
      const direction = operationDetails.hr_threshold === "low" ? "<" : ">";
      const hazardRatio = operationDetails.hazard_ratio
        ? `, Hazard Ratio ${direction} ${operationDetails.hazard_ratio}`
        : "";
      return `Survival-Protective Genes are genes expressed significantly higher (p < 0.05${hazardRatio}) in long survival patients. Survival-Hazard Genes are genes expressed significantly higher (p < 0.05${hazardRatio}) in short survival patients.`;
    };

    const getProliferationDescription = () => {
      const crisper = operationDetails.sig_percent_crispr
        ? `${operationDetails.sig_percent_crispr}% of`
        : "";
      return `Proliferation genes are those that show a significant impact on cell viability in ${crisper} tested ${histological_subtype} cell lines in CRISPR-Cas9 ${operationDetails.sig_condition} RNAi assays.`;
    };

    switch (type) {
      case "Tumorigenesis":
        this.setState({
          descriptionText: getTumorigenesisDescription(),
        });
        setPagination("tumorigenesis");
        return response?.tumorigenesis?.data || [];

      case "Survival":
        this.setState({
          descriptionText: getSurvivalDescription(),
        });
        setPagination("survival");
        return response?.survival?.data || [];

      case "Proliferation":
        this.setState({
          descriptionText: getProliferationDescription(),
        });
        setPagination("proliferation");
        return response?.proliferation?.data || [];

      case "Drug_Sensitivity":
        this.setState({
          descriptionText: `Pansensitive Genes are defined as genes associated with sensitivity (or lack of resistance) to NCCN-recommended drugs for ${histological_subtype} treatment. Panresistant Genes are those associated with resistance (or lack of sensitivity) to NCCN-recommended drugs for ${histological_subtype} treatment.`,
        });
        setPagination("drug_sensitivity");
        return response?.drug_sensitivity?.data || [];

      case "Pathway":
        this.setState({
          descriptionText:
            response?.pathways?.data?.length > 0
              ? `The network genes that were also present in the
               ${this.props?.reduxData?.furtureAnalysisDetails?.pathway} are listed below` : "",
        });
        setPagination("pathways");
        return response?.pathways?.data || [];
      case "Centrality":
        this.setState({
          descriptionText:
            response?.centrality?.data?.length > 0
              ? `Top ${this.props?.reduxData?.furtureAnalysisDetails?.top_percentage} % of ${this.props?.reduxData?.furtureAnalysisDetails?.centrality}`
              : "",
        });
        this.setState({
          totalRows: response?.centrality?.pagination?.total,
          page: response?.centrality?.pagination?.page,
          rowsPerPage: response?.centrality?.pagination?.pageSize,
        });

        return response?.centrality?.data;
      case "Significant_Condition":
        this.setState({
          descriptionText: `The recommended input gene lists for CMap/PharmOmics were derived to identify mechanisms that inhibit
${this.props?.reduxData?.furtureAnalysisDetails?.histological_subtype} proliferation, induce immune response, and enhance therapeutic response`,
        });
        const up_regulated = response?.significantGenes?.goodGenes;
        const down_regulated = response?.significantGenes?.badGenes;

        return [
          {
            genesType: "Upregulated Genes",
            genesList: up_regulated?.join(", ") || "-",
          },
          {
            genesType: "Downregulated Genes",
            genesList: down_regulated?.join(", ") || "-",
          },
        ];
      default:
        return [];
    }
  };

  handlePathway = (value, page, limit) => {
    this.setState({ tableColumn: getColumns(value) });
    if (this.props?.reduxData?.furtureAnalysisDetails.pathway) {
      this.constructData(value, page, limit);
    }
  };

  handleBlobDownload = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  handleGenerateImage = () => {
    const isFromProject = this.props?.reduxData?.furtureAnalysisDetails?.isFromProject || false;

    // For Projects, skip image generation and call report download directly
    if (isFromProject) {
      this.handleGenerateReportDownload(null);
      return;
    }

    // For Networks, generate image from cytoscape
    if (this.cytoscapeRef.current) {
      this.cytoscapeRef.current.generateImage();
    }
  };

  base64ToBlob = (base64Data, contentType = "image/png") => {
    const byteCharacters = atob(base64Data.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  handleGenerateReportDownload = async (image) => {
    this.setState({ loading: true });
    const { reduxData } = this.props;

    try {
      let imageBlob = null;

      if (image) {
        imageBlob = this.base64ToBlob(image);
      }
      const selectedOptions = SELECTOPTIONS.filter(
        (option) =>
          reduxData.furtureAnalysisDetails.viewDetails[option.value]?.selected
      );

      if (selectedOptions.length > 0) {
        await this.generateAllResultsReport(
          reduxData.furtureAnalysisDetails,
          imageBlob
        );
      }
    } catch (error) {
      this.setState({
        errorMessage: "Failed to generate report. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  generateAllResultsReport = async (operationDetails, imageBlob) => {
    try {
      const response = await fetchTableDataAllDownload(
        operationDetails,
        imageBlob,
        {
          responseType: "blob", // Ensure the response is treated as a Blob
        }
      );

      if (!response) {
        throw new Error("Failed to fetch data");
      }

      // Check if response is a Blob
      if (response instanceof Blob) {
        const date = new Date().toISOString().split("T")[0];
        const filename = `All_Analysis_Report_${date}.pdf`;
        this.handleBlobDownload(response, filename);
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      throw error;
    }
  };

  fetchCytoscapeDetails = () => {
    this.setState({ loader: true });
    axiosInstance
      .get(
        `${process.env.REACT_APP_BASE_URL}api/network-cytoscape?id=${this.props.reduxData.cytoscapeData.cytoscapeID}`
      )
      .then((res) => {
        const data = res?.data?.data || {};

        this.setState({
          nodeData: this.extractNodeData(data),
        });
      })
      .catch((err) => {
        showErrorToast(
          err?.response?.data?.error?.message || "Error while fetching network",
          false
        );
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  };

  extractNodeData = (data) => ({
    nodes: data?.cytoscape?.nodes || [],
    edges: data?.cytoscape?.edges || [],
  });

  render() {
    const {
      selectedOption,
      allResultsChecked,
      loading,
      errorMessage,
      tableData,
      tableColumn,
    } = this.state;
    const { reduxData } = this.props;
    const isGenerateReportDisabled =
      !allResultsChecked &&
      !reduxData.furtureAnalysisDetails.viewDetails[selectedOption]?.selected;

    return (
      <div className="row">
        <ToastContainer />
        <div className="col-lg-3 col-md-4 col-sm-12 mt-2">
          <div className="card card-furture-analysis">
            <div className="top-container-div">
              <Link
                className="btn-link-primary"
                to={{ pathname: "/app/discover/furtherAnalysis", search: `?activeTab=${new URLSearchParams(this.props.location.search).get('activeTab') || 'networks'}` }}
              >
                <div className="d-inline-flex">
                  <img src={backlogo} alt="" />
                  <span
                    style={{ color: "#333333", fontWeight: 400 }}
                    className="ms-1"
                  >
                    Back
                  </span>
                </div>
              </Link>

              <div className="title-div fw-bold d-flex align-items-center mt-2">
                Network Generation
              </div>

              <div className="further-analysis-filter">
                <div className="mt-3">
                  {SELECTOPTIONS.map((item, index) => (
                    <div
                      className="result-gene-container mb-2"
                      key={index}
                      onClick={() => this.handleSelection(item.value)}
                      style={{
                        backgroundColor:
                          selectedOption === item.value ? "#5460D1" : "#EAEAEA",
                        color:
                          selectedOption === item.value ? "white" : "inherit",
                      }}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* <div className="drugGroup-button"> */}
            <div className="furture-analysis-button">
              <div className="d-flex align-items-center me-2">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    id="all-results-checkbox"
                    checked={allResultsChecked}
                    disabled
                  // onChange={this.handleAllResultsCheckboxChange}
                  />
                  <Label
                    for="all-results-checkbox"
                    check
                    className="checkbox-label ml-2"
                    style={{ color: "#333333" }}
                  >
                    All Results
                  </Label>
                </FormGroup>
              </div>
              <Button
                className="w-80"
                color="primary"
                onClick={this.handleGenerateImage}
                disabled={isGenerateReportDisabled}
              >
                Generate Report
              </Button>
            </div>
            {/* </div> */}
          </div>
        </div>

        <div className="col-lg-9 col-md-8 col-sm-12 mt-2">
          <div className="card section-container">
            <div className="gene-data-container">
              <div className="d-flex justify-content-between">
                <div >
                  <span className="title-div fw-bold">{selectedOption.replace("_", " ")}</span>
                  {tableData?.length > 0 && selectedOption === "Significant_Condition" &&
                    <span className="fw-medium text-capitalize">({this.props?.reduxData?.furtureAnalysisDetails.significantCondition} {" "}-  {" "}{this.state.selectedOperations})</span>
                  }
                </div>
              </div>

              {this.state.nodeData?.nodes?.length > 0 && (
                <div className="further-analysis-cytoscape">
                  <CytoscapeGraph
                    ref={this.cytoscapeRef}
                    nodeDetails={this.state.nodeData}
                    dataType={""}
                    onImageGenerate={this.handleGenerateReportDownload}
                  />
                </div>
              )}

              <div className="description-text my-2">
                {this.state.descriptionText}
              </div>

              <div
                className={`table-container-analysis mt-3 ${(loading && " blur-content") || ""
                  }`}
              >
                <CustomTable
                  key={`${selectedOption}`}
                  columns={tableColumn}
                  data={tableData}
                  errorMessage={errorMessage}
                  totalRows={this.state.totalRows}
                  rowsPerPage={this.state.rowsPerPage}
                  currentPage={this.state.page}
                  tableType={this.state.tableType}
                  handlePageChange={this.handlePageChange}
                  handleRowsPerPageChange={this.handleRowsPerPageChange}
                />
              </div>
            </div>
          </div>
        </div>
        {loading && (
          <div className="backdrop">
            <div className="loader">
              <Loader type="ball-pulse-rise" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(FurtureAnalysisResult);
